export const getIsFetching = state => state.createPassword.isFetching;
export const getErrorMessage = state => state.createPassword.errorMessage;
